import React from "react"
import { FormattedMessage } from "react-intl"
// eslint-disable-next-line import/no-restricted-paths
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { IlloCarrotCards } from "../atoms/Illustrations"
import { Spacer } from "../atoms/Atoms"
import { H2 } from "@carrotfertility/carotene"
import { Body } from "../atoms/Bodies"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"

// view component when card is already activated
const ActivateDone = () => (
  <MasterLayout header={null}>
    <div className="flex-auto flex flex-column justify-center items-center w-100 vh-100-ns">
      <div className={`flex-none br3 bg-pampas animate-all mw6-ns pv4`}>
        <div className="tc pa4">
          <IlloCarrotCards />
          <Spacer height={1} />
          <H2>
            <FormattedMessage defaultMessage="Carrot Card already activated" />
          </H2>
          <Spacer height={0.25} />
          <Body color="black-80">
            <FormattedMessage defaultMessage="Your Carrot Card is already active. You may use it now." />
          </Body>
          <Spacer height={1} />
          <ButtonPrimary to="/">
            <FormattedMessage defaultMessage="Return home" />
          </ButtonPrimary>
        </div>
      </div>
    </div>
  </MasterLayout>
)

export default ActivateDone
